import React__default, { useState } from 'react';
import { A as AddGroupChannelView } from '../../chunks/bundle-DtycZWOo.js';
import { useGroupChannelListContext } from '../context.js';
import '../../ui/IconButton.js';
import '../../chunks/bundle-C7jYHvwG.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../CreateChannel.js';
import '../../CreateChannel/components/CreateChannelUI.js';
import '../../chunks/bundle-CHzQIw7_.js';
import '../../sendbirdSelectors.js';
import '../../chunks/bundle-MkyS3j4-.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../CreateChannel/components/InviteUsers.js';
import '../../chunks/bundle-CIN9yQRB.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../chunks/bundle-DfDrbjM5.js';
import '../../chunks/bundle-MyLy9AIu.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../chunks/bundle-DkviGBGz.js';
import 'react-dom';
import '../../ui/Button.js';
import '../../chunks/bundle-DImSV9VW.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '../../ui/UserListItem.js';
import '../../chunks/bundle-gQ2a8Eki.js';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../CreateChannel/components/SelectChannelType.js';
import '../../chunks/bundle-Cq6wCLlD.js';

var AddGroupChannel = function () {
    var _a = useState(false), createChannelVisible = _a[0], setCreateChannelVisible = _a[1];
    var _b = useGroupChannelListContext(), onChannelCreated = _b.onChannelCreated, onBeforeCreateChannel = _b.onBeforeCreateChannel, onCreateChannelClick = _b.onCreateChannelClick;
    return (React__default.createElement(AddGroupChannelView, { createChannelVisible: createChannelVisible, onChangeCreateChannelVisible: setCreateChannelVisible, onCreateChannelClick: onCreateChannelClick, onBeforeCreateChannel: onBeforeCreateChannel, onChannelCreated: onChannelCreated }));
};

export { AddGroupChannel, AddGroupChannel as default };
//# sourceMappingURL=AddGroupChannel.js.map
